import PersonalPortfolio from './PersonalPortfolio'

export default PersonalPortfolio
